<template>
    <v-card>
        <!-- Menú desplegable --> 
        <v-navigation-drawer
        v-model="primaryDrawer.model"
        :temporary="primaryDrawer.type === 'temporary'"
        app
        >
            <v-list-item class="my-5" >
                
                    <v-img
                        contain
                        src="../assets/img/lacartaweb/lacartaweb800.png"
                        max-height="80px"
                        max-width="150px"
                        aspect-ratio
                        @click="navegarNavBar('Inicio')"
                    ></v-img>
                
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item class="mx-5 mt-4">
                <v-list-item-title class="grey--text text--darken-1" @click="navegarNavBar('Inicio')">Inicio</v-list-item-title>
            </v-list-item>
            <v-list-item class="mx-5 mt-2">
                <v-list-item-title class="grey--text text--darken-1" @click="navegarNavBar('LectorQR')">Lector QR</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <!--
            <v-list-item class="mx-5 mt-4">
                <v-list-item-title class="grey--text text--darken-1" @click="navegarNavBar('MasInfo')">+Info</v-list-item-title>
            </v-list-item>
            
            <v-list-item class="mx-5 mt-4">
                <v-list-item-title class="grey--text text--darken-1" @click="navegarNavBar('Contacto')">Contactar</v-list-item-title>
            </v-list-item>
            -->

        </v-navigation-drawer>


        <!-- Barra de navegación -->
        <v-app-bar
        app
        >
            <v-toolbar-title class="ml-2">
                    <v-img
                        contain
                        src="@/assets/img/lacartaweb/lacartaweb800.png"
                        max-height="50px"
                        max-width="100px"
                        aspect-ratio
                        @click="navegarNavBar('Inicio')"
                    ></v-img>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-app-bar-nav-icon  
                class="mr-1"
                @click.stop="primaryDrawer.model = !primaryDrawer.model"
            ></v-app-bar-nav-icon>
        
        </v-app-bar>

    </v-card>

    
</template>

<script>

    export default {
        data () {
            return {
                primaryDrawer: {
                    model: null,
                    type: 'temporary',
                },
                urlBase: this.$store.state.url_base,
            }
        },
        methods: {    
            navegarNavBar: function (tipo) {
                this.primaryDrawer.model = false
                this.$store.commit("cambiarCiudadID", '');
                this.$store.commit("cambiarCiudadSlug", '');
                this.$store.commit("cambiarComercioID", '');
                this.$store.commit("cambiarComercioSlug", '');
                this.$store.commit("cambiarTipo", tipo);

                if(tipo === 'Inicio') {
                    window.location.href = this.urlBase;
                } else if (tipo === 'LectorQR') {
                    this.$store.commit("cambiarTipo", "LectorQR");
                    window.location.href = this.urlBase+'/lectorqr';
                } else if (tipo === 'MasInfo') {
                    this.$store.commit("cambiarTipo", "LectorQR");
                    window.location.href = this.urlBase+'/masinfo';
                }
            },
        }
    };
</script>
